import React, { Fragment } from 'react';
import {
  Button, Modal, ModalHeader, ModalBody, ModalFooter,
  Col, Form, FormGroup, Label, Input, FormCheck, Row
} from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import "react-datetime/css/react-datetime.css";
import moment from 'moment';
import CampaignScheduleFields, { sendByDate, adjustExpiredLaunch, campaignTimeZone } from './CampaignScheduleFields';
import { getSMTPConfigList, getGroupList, createPhishingCampaign } from "../../../API/PhishingAPI";
import PhishingCustomSelect from "./PhishingCustomSelect";
import SimulationTemplateSelect from '../TemplateGallery/SimulationTemplateSelect';
import CampaignLinkDomainSelect from '../DeliverySettings/CampaignLinkDomainSelect';
import { DeliverySettingsPanel } from '../DeliverySettings/DeliverySettings';
import RecipientDomainGate from '../DeliverySettings/RecipientDomainGate';

class CampaignModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      modal: this.props.open,
      isEdit: this.props.campaign ? true : false,
      isCopied: this.props.isCopied,
      campaign: {
        name: "",
        page: {},
        template: {},
        url: '',
        link_domain_id: '',
        launch_date: moment().add(10, "minutes"),
        smtp: {},
        groups: []
      },
      smtpConfigList: [],
      groupList: [],
      errors: {},
      linkReady: false,
      recipientsReady: false,
      domainRevision: 0
    }
    this.toggle = this.toggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.loadSMTPConfig = this.loadSMTPConfig.bind(this);
    this.loadGroupList = this.loadGroupList.bind(this);
    this.handleChangeForPhishingSelect = this.handleChangeForPhishingSelect.bind(this);
    this.submit = this.submit.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleValidation = this.handleValidation.bind(this);
    this.parseDate = this.parseDate.bind(this);
  }

  componentDidMount() {
    if (this.state.isEdit) {
      if (this.state.isCopied) {
        const { id, name, ...rest } = this.props.campaign;
        this.setState({
          campaign: {
            ...rest,
            name: "Copy of " + name,
            launch_date: moment().add(10, "minutes"),
          }
        })
      } else {
        this.setState({
          campaign: this.props.campaign
        });
      }
    }
    this.loadSMTPConfig();
    this.loadGroupList();
  }

  handleChange(event) {
    const key = event.target.name;
    const value = event.target.type === 'checkbox'
      ? event.target.checked : event.target.value;
    this.setState(updater => ({
      campaign: {
        ...updater.campaign,
        [key]: value
      }
    }));
  }

  handleLinkDomainChange = domain => this.setState(current => ({ linkReady: !!domain,
    campaign: { ...current.campaign, url: domain?.url || '', link_domain_id: domain?.id || '' },
    errors: { ...current.errors, url: '' } }));
  handleRecipientsReady = ready => this.setState({ recipientsReady: ready });
  closeDelivery = () => this.setState(current => ({ deliveryOpen: false, domainRevision: current.domainRevision + 1 }));

  handleDateChange(selectedDate, key) {
    this.setState(updater => ({
      campaign: {
        ...updater.campaign,
        [key]: selectedDate
      }
    }));
  }

  parseDate(date) {
    if (date && (moment.isMoment(date) || moment.isDate(date))) {
      return new Date(date.valueOf()).toISOString();
    }
    return date; // not able to format
  }

  handleChangeForPhishingSelect(event) {
    const key = event.target.name;
    var value;
    if (event.target.multiple) {
      value = Array.from(event.target.selectedOptions, option => {
        var obj = {};
        obj["name"] = option.value;
        return obj;
      });
    } else {
      value = { name: event.target.value };
    }
    this.setState(updater => ({
      campaign: {
        ...updater.campaign,
        [key]: value
      }
    }));
  }

  loadSMTPConfig() {
    getSMTPConfigList()
      .then(res => {
        res.forEach((item, i) => {
          item.modified_date = (new Date(item.modified_date)).toLocaleString(undefined, { dateStyle: "full", timeStyle: "medium" })
        });
        this.setState({
          smtpConfigList: res
        });
      }).catch(error => {
        // TODO: Handling is pending when there will be some issue getting data.
      });
  }

  loadGroupList() {
    getGroupList()
      .then(res => {
        console.log(res);
        res.forEach((item, i) => {
          item.modified_date = (new Date(item.modified_date)).toLocaleString(undefined, { dateStyle: "full", timeStyle: "medium" })
        });
        this.setState({
          groupList: res
        });
      }).catch(error => {
        // TODO: Handling is pending when there will be some issue getting data.
      });
  }

  handleValidation() {
    var fields = this.state.campaign;
    var errors = {};
    var formIsValid = true;
    //Reset the errors
    this.setState({ errors: null });

    //Name cannot be empty
    if (!fields["name"]) {
      formIsValid = false;
      errors["name"] = "Cannot be empty";
    }

    if (!this.state.linkReady || !fields["url"]) {
      formIsValid = false;
      errors["url"] = this.props.t('campaign_link_domains.required');
    }

    if (!this.state.recipientsReady) { formIsValid = false; errors.recipients = this.props.t('authenticated_domains.policy_error'); }
    if (!fields["launch_date"]) {
      formIsValid = false;
      errors["launch_date"] = "Launch date cannot be empty";
    }

    if (!fields["smtp"] || Object.keys(fields["smtp"]).length === 0) {
      formIsValid = false;
      errors["smtp"] = "SMTP config can not be empty";
    }

    if (!fields["page"] || Object.keys(fields["page"]).length === 0) {
      formIsValid = false;
      errors["page"] = "Landing Page can not be empty";
    }

    if (!fields["template"] || Object.keys(fields["template"]).length === 0) {
      formIsValid = false;
      errors["template"] = "Email template can not be empty";
    }

    if (!fields["groups"] || !Array.isArray(fields["groups"]) || fields["groups"].length == 0) {
      formIsValid = false;
      errors["groups"] = "Select at least one group";
    }

    if (!moment.isMoment(fields["launch_date"]) || !fields["launch_date"].isValid()) {
      formIsValid = false;
      errors["launch_date"] = "Launch date is Invalid";
    }

    this.setState({ errors: errors });
    return formIsValid;
  }

  toggle() {
    if (this.state.modal && typeof this.props.onClose === 'function') {
      this.props.onClose(); // call onClose when closing
    }
    this.setState({
      modal: !this.state.modal,
      campaign: {
        name: "",
        page: {},
        template: {},
        url: '',
        link_domain_id: '',
        launch_date: moment().add(10, "minutes"),
        smtp: {},
        groups: []
      },
      errors: {},
      linkReady: false
    })
  }

  selectedRecipients() {
    return (this.state.campaign.groups || []).flatMap(group => this.state.groupList.find(item => item.name === group.name)?.targets || []);
  }

  submit() {
    if (!this.handleValidation()) {
      return;
    }
    const campaign = { ... this.state.campaign };
    const schedule = adjustExpiredLaunch(campaign.launch_date);
    campaign.launch_date = schedule.launchDate;
    if (schedule.adjusted) {
      this.setState(current => ({ campaign: { ...current.campaign, launch_date: schedule.launchDate } }));
      toast.info(this.props.t('simulation_wizard.schedule_adjusted', { date: schedule.launchDate.format('L LTS'), zone: campaignTimeZone(schedule.launchDate) }));
    }
    // format date only on launching
    campaign.send_by_date = this.parseDate(sendByDate(campaign.launch_date, this.selectedRecipients().length));
    campaign.launch_date = this.parseDate(campaign.launch_date);
    console.log(campaign);
    createPhishingCampaign(campaign)
      .then(result => {
        if (result?.schedule_adjusted) toast.info(this.props.t('simulation_wizard.schedule_adjusted', {
          date: new Date(result.launch_date).toLocaleString(), zone: Intl.DateTimeFormat().resolvedOptions().timeZone
        }));
        this.toggle();
        this.props.onSubmit();
      }).catch(error => {
        const messageKey = this.state.isEdit ? 'errors.updating' : 'errors.creating';
        toast["error"](this.props.t(messageKey, { element: 'Campaign', message: error.message }));
      });
  }

  render() {
    const { t, i18n } = this.props;

    const openButton = this.props.showOpenButton &&
      <Button className="mb-2 mr-2 btn-icon btn-shadow" size="lg" color="success"
        onClick={() => this.toggle()}>
        <i className="lnr-plus-circle btn-icon-wrapper"> </i>
        {t('phishing_campaign.actions.create')}
      </Button>;

    return (
      <Fragment>
        {openButton}
        <Modal isOpen={this.state.modal} toggle={this.toggle} size="lg">
          <ModalHeader toggle={this.toggle}>{t('phishing_campaign.actions.create')}</ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>Name:</Label>
              <Input type="text" name="name" id="name" value={this.state.campaign.name} onChange={this.handleChange} />
              <span style={{ color: "red" }}>{this.state.errors["name"]}</span>
            </FormGroup>
            <FormGroup>
              <Label for="simulation-template-select">{t('template_gallery.menu')}</Label>
              <SimulationTemplateSelect value={this.state.campaign.simulation_template_id || ''}
                onChange={set => this.setState(current => ({ campaign: { ...current.campaign,
                  simulation_template_id: set?.id || '', template: set ? { name: set.message.name } : {},
                  page: set?.page ? { name: set.page.name } : {} } }))} />
              {!this.state.campaign.simulation_template_id && this.state.campaign.template?.name &&
                <small className="d-block text-muted mt-2">{t('template_gallery.legacy_campaign', {
                  message: this.state.campaign.template.name, page: this.state.campaign.page?.name || ''
                })}</small>}
              <span style={{ color: "red" }}>{this.state.errors["template"] || this.state.errors["page"]}</span>
            </FormGroup>
            <CampaignLinkDomainSelect domainId={this.state.campaign.link_domain_id} value={this.state.campaign.url}
              onChange={this.handleLinkDomainChange} onOpenSettings={() => this.setState({ deliveryOpen: true })}
              error={this.state.errors.url} t={t} />
            <RecipientDomainGate recipients={this.selectedRecipients()}
              revision={this.state.domainRevision} onReady={this.handleRecipientsReady} onOpenSettings={() => this.setState({ deliveryOpen: true })} t={t} />
            <CampaignScheduleFields launchDate={this.state.campaign.launch_date} recipientCount={this.selectedRecipients().length}
              error={this.state.errors["launch_date"]} onLaunchChange={data => this.handleDateChange(data, "launch_date")} t={t} />
            <FormGroup>
              <Label>Sending Profile:</Label>
              <PhishingCustomSelect name="smtp" data={this.state.smtpConfigList}
                selected={this.state.campaign.smtp} onChange={this.handleChangeForPhishingSelect} />
              <span style={{ color: "red" }}>{this.state.errors["smtp"]}</span>
            </FormGroup>
            <FormGroup>
              <Label>Groups:</Label>
              <PhishingCustomSelect name="groups" data={this.state.groupList}
                onChange={this.handleChangeForPhishingSelect} multiple={true} />
              <span style={{ color: "red" }}>{this.state.errors["groups"]}</span>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="link" onClick={this.toggle}>{t('phishing_campaign.actions.cancel')}</Button>
            <Button color="primary" disabled={!this.state.linkReady || !this.state.recipientsReady} onClick={this.submit}>{t('phishing_campaign.actions.submit')}</Button>{' '}
          </ModalFooter>
        </Modal>
        {this.state.deliveryOpen && <Modal isOpen toggle={this.closeDelivery} size="xl" scrollable className="delivery-settings-dialog">
          <ModalHeader toggle={this.closeDelivery}>{t('delivery_settings.title')}</ModalHeader>
          <ModalBody><DeliverySettingsPanel t={t} /></ModalBody>
          <ModalFooter><Button color="link" onClick={this.closeDelivery}>{t('template_gallery.cancel')}</Button></ModalFooter>
        </Modal>}
      </Fragment>
    )
  }
}

CampaignModal.defaultProps = {
  open: false,
  showOpenButton: true
}

export default withTranslation()(CampaignModal)
